import { createAxiosInstance } from '@/plugins/axios.plugin';

export class States {
  static SERVICE_NAME = 'states';

  constructor() {
    this.clientContent = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
    this.clientState = createAxiosInstance({ baseURL: process.env.STATE_SERVICE_API, useAccessToken: true });
  }

  getObjectState({ stateUuid }) {
    return this.clientState.get(`/state/${stateUuid}`);
  }

  putObjectState({ id, payload }) {
    return fetch(`${process.env.STATE_SERVICE_API}/state`, {
      method  : 'PUT',
      body    : JSON.stringify({ id, payload }),
      headers : {
        'Content-Type' : 'application/json',
        Authorization  : localStorage.getItem(`${process.env.APPLICATION_ALIAS}_accessToken`)
      },
      keepalive: true
    })
      .catch(() => null);
  }

  getH5pStateUuid({ academicMainId, topicId }) {
    return this.clientContent.get(`/content/academics-main/${academicMainId}/topics/${topicId}/h5p/uuid`);
  }
}

export default new States();

